import { featuredProducts } from '@/mocks/homeData';

const FeaturedProducts = () => (
  <section className="relative bg-background-50 py-16 md:py-24">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-16">
        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-accent-600 mb-3">Destaques</p>
          <h2 className="text-4xl md:text-6xl font-heading font-bold text-foreground-950 leading-tight">
            Destaques da<br />Semana
          </h2>
        </div>
        <p className="text-sm text-foreground-600 max-w-sm leading-relaxed">
          Produtos mais acessados do nosso <strong>Hoobuy Spreadsheet</strong> esta semana. Links verificados e atualizados.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="md:col-span-2 relative group rounded-2xl overflow-hidden aspect-[3/4] md:aspect-[4/3] cursor-pointer">
          <img
            src={featuredProducts[0].imageUrl}
            alt={featuredProducts[0].name}
            title={featuredProducts[0].name + " - Hoobuy Spreadsheet"}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-6">
            <span className="inline-block px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-semibold rounded-full mb-2">
              Hoobuy vs Outros: ★★★★★
            </span>
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-background-50">{featuredProducts[0].name}</h3>
            <p className="text-sm text-background-50/80 mt-1">{featuredProducts[0].desc}</p>
          </div>
        </div>

        <div className="relative group rounded-2xl overflow-hidden aspect-[3/4] cursor-pointer">
          <img
            src={featuredProducts[1].imageUrl}
            alt={featuredProducts[1].name}
            title={featuredProducts[1].name + " - Hoobuy Spreadsheet"}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-6">
            <span className="inline-block px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-semibold rounded-full mb-2">
              Hoobuy vs Outros: ★★★★★
            </span>
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-background-50">{featuredProducts[1].name}</h3>
            <p className="text-sm text-background-50/80 mt-1">{featuredProducts[1].desc}</p>
          </div>
        </div>

        <div className="relative group rounded-2xl overflow-hidden aspect-[3/4] cursor-pointer">
          <img
            src={featuredProducts[2].imageUrl}
            alt={featuredProducts[2].name}
            title={featuredProducts[2].name + " - Hoobuy Spreadsheet"}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-6">
            <span className="inline-block px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-semibold rounded-full mb-2">
              Hoobuy vs Outros: ★★★★★
            </span>
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-background-50">{featuredProducts[2].name}</h3>
            <p className="text-sm text-background-50/80 mt-1">{featuredProducts[2].desc}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default FeaturedProducts;